import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import { makeStyles, withStyles } from "@material-ui/core/styles";


const btnTransition = "rotate 150ms";

export const useStyles = makeStyles(theme => ({
    section: {
        border: `1px solid ${theme.palette.grey[300]}`,
    },
    btnOpen: {
      transition: btnTransition,
      rotate: "0.5turn",
    },
    btnClosed: {
      transition: btnTransition,
    },
    cameraName: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: 48,
        fontSize: 16,
        fontWeight: "bold",
        color: theme.palette.grey[900],
    },
}));

export const Accordion = withStyles({
    root: {
        border: "1px solid lightgrey",
        borderRadius: 4,
        boxShadow: "none",
        margin: "1em 5%",
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "1em 5%",
            "&:first-child": {
                marginTop: "1em",
            },
        },
    },
    expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
    root: {
        marginBottom: -1,
        minHeight: 56,
        padding: 0,
        "&$expanded": {
            minHeight: 56,
        },
        cursor: "default",
    },
    content: {
        alignItems: "center",
        justifyContent: "space-between",
        margin: 0,
        "&$expanded": {
            margin: 0,
        },
    },
    expanded: {},
    expandIcon: {
        order: -1,
        padding: 0,
        margin: "0 0.5em",
    },
})(MuiAccordionSummary);

export const AccordionDetails = withStyles({
    root: {
        padding: 0,
        display: "flex",
        flexDirection: "column",
    },
})(MuiAccordionDetails);
